/**
 * Resolve product picks against the live catalog (preserves pick order).
 * @param {Array<{category?: string, id?: string}>} allProducts
 * @param {Array<{category_slug?: string, product_id?: string, category?: string, id?: string}>} picks
 * @param {number} [limit=8]
 */
export function resolveProductsFromPicks(allProducts, picks, limit = 8) {
  const list = Array.isArray(picks) ? picks : [];
  if (list.length === 0) return [];

  const map = new Map();
  for (const p of allProducts) {
    if (!p?.category || p.id == null) continue;
    map.set(`${p.category}:${String(p.id)}`, p);
  }

  const resolved = [];
  for (const pick of list) {
    if (resolved.length >= limit) break;
    const cat = String(pick.category_slug || pick.category || '').trim();
    const id = String(pick.product_id ?? pick.id ?? '').trim();
    if (!cat || !id) continue;
    const product = map.get(`${cat}:${id}`);
    if (product) resolved.push(product);
  }
  return resolved;
}

/**
 * Resolve admin-picked featured products against the live catalog.
 * @param {Array<{category?: string, id?: string}>} allProducts
 * @param {Array<{category_slug?: string, product_id?: string, category?: string, id?: string}>} picks
 * @param {number} [fallbackCount=8]
 */
export function resolveFeaturedProducts(allProducts, picks, fallbackCount = 8) {
  const resolved = resolveProductsFromPicks(allProducts, picks, fallbackCount);
  if (resolved.length > 0) return resolved;
  return [...allProducts].filter((p) => p.image).slice(0, fallbackCount);
}

/**
 * Home featured shelf — most viewed first, then admin picks, then catalog fallback.
 * @param {Array<{category?: string, id?: string}>} allProducts
 * @param {{ trendingPicks?: Array, manualPicks?: Array, limit?: number }} options
 */
export function resolveHomeFeaturedProducts(allProducts, { trendingPicks = [], manualPicks = [], limit = 12 } = {}) {
  const trending = resolveProductsFromPicks(allProducts, trendingPicks, limit);
  if (trending.length > 0) return trending;
  return resolveFeaturedProducts(allProducts, manualPicks, limit);
}
